import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { DatePipe } from '@angular/common';


import { PrestacaoInformacoesRoutingModule } from './prestacao-informacoes-routing.module';
import { AtualizacaoInformacoesLotePesquisaComponent } from './atualizacao-informacoes-risco/atualizacao-informacoes-lote-pesquisa.component';
import { AcompanhamentoProcessualPesquisaComponent } from './acompanhamento-processual/acompanhamento-processual-pesquisa.component';
import { AcompanhamentoProcessualEnvioComponent } from './acompanhamento-processual/acompanhamento-processual-envio.component';
import { AcompanhamentoProcessualListagemComponent } from './acompanhamento-processual/acompanhamento-processual-listagem.component';
import { AcompanhamentoProcessualDetalheComponent } from './acompanhamento-processual/acompanhamento-processual-detalhe.component';
import { AcompanhamentoProcessualCadastroComponent } from './acompanhamento-processual/acompanhamento-processual-cadastro.component';
import { AtualizacaoInfoRiscoEnvioComponent } from './atualizacao-informacoes-risco/atualizacao-info-risco-envio.component';
import {  AtualizacaoInfoRiscoPesquisaComponent } from './atualizacao-informacoes-risco/atualizacao-info-risco-pesquisa.component';
import {  AtualizacaoInfoRiscoListagemComponent } from './atualizacao-informacoes-risco/atualizacao-info-risco-listagem.component';
import {  AtualizacaoInfoRiscoDetalheComponent } from './atualizacao-informacoes-risco/atualizacao-info-risco-detalhe.component';
import { AtualizacaoInfoRiscoCadastroComponent } from './atualizacao-informacoes-risco/atualizacao-info-risco-cadastro/atualizacao-info-risco-cadastro.component';
import { AcompanhamentoDeprCadastroComponent } from './acompanhamento-depr/acompanhamento-depr-cadastro/acompanhamento-depr-cadastro.component';
import { AcompanhamentoDeprStepperComponent } from './acompanhamento-depr/acompanhamento-depr-cadastro/acompanhamento-depr-stepper/acompanhamento-depr-stepper.component';
import { AbaDocumentoComponent } from './acompanhamento-depr/acompanhamento-depr-cadastro/aba-documento/aba-documento.component';
import { AcompanhamentoDeprPesquisaComponent } from './acompanhamento-depr/acompanhamento-depr-pesquisa/acompanhamento-depr-pesquisa.component';
import { AcompanhamentoDeprListagemComponent } from './acompanhamento-depr/acompanhamento-depr-pesquisa/acompanhamento-depr-listagem/acompanhamento-depr-listagem.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AbaHistoricoComponent } from './acompanhamento-depr/acompanhamento-depr-cadastro/aba-historico/aba-historico.component';
import {SeparadorSequenciaPipe} from '../../pipes/separador-sequencia.pipe';
import { BnStepperComponent } from '@bndes/bndes-ux4/bn-stepper';
import { BnCnpjPipe } from '@bndes/bndes-ux4/pipes/cnpj';


@NgModule({
    imports: [
        SharedModule,
        PrestacaoInformacoesRoutingModule,
        NgSelectModule,
        SeparadorSequenciaPipe,
        BnStepperComponent,
    ],
  declarations: [
    AtualizacaoInformacoesLotePesquisaComponent,

    AcompanhamentoProcessualPesquisaComponent,
    AcompanhamentoProcessualListagemComponent,
    AcompanhamentoProcessualDetalheComponent,
    AcompanhamentoProcessualEnvioComponent,
    AcompanhamentoProcessualCadastroComponent,

    AtualizacaoInfoRiscoPesquisaComponent,
    AtualizacaoInfoRiscoListagemComponent,
    AtualizacaoInfoRiscoCadastroComponent,
    AtualizacaoInfoRiscoDetalheComponent,
    AtualizacaoInfoRiscoEnvioComponent,

    AcompanhamentoDeprCadastroComponent,
    AcompanhamentoDeprStepperComponent,
    AbaDocumentoComponent,
    AcompanhamentoDeprPesquisaComponent,
    AcompanhamentoDeprListagemComponent,
    AbaHistoricoComponent,

  ],
  providers: [
    DatePipe,
    BnCnpjPipe,
  ]
})
export class PrestacaoInformacoesModule { }
